import React from 'react'
import PropTypes from 'prop-types'
import useFaceProfile from '../../shared/utils/useFaceProfile'
import DOMPurify from 'dompurify'
import './index.css'

const Welcome = props => {
  const { firstName } = useFaceProfile()
  return (
    <main aria-label='Content'>
      <div className='u-paddingVert40'>
        <div className='u-sizeConstrained'>
          <div className='Grid Grid--alignMiddle Grid--withGutter'>
            <div className='u-lg-sizeFull'>
              <div className='Content u-sm-marginBottom20 u-md-marginBottom20'>
                <h1 className='Type-Display u-textColorNeutral'>
                  <span className='FirstName'>{firstName || ''}</span>
                  {firstName ? ', ' : ''}
                  {props.content.heading}
                </h1>
                <div
                  className='u-textSizeMsrp1'
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.content.body) }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}

export default Welcome

Welcome.propTypes = {
  content: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
  }).isRequired,
}
